import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

function Heading(props) {
  const { name, data } = props;

  return (
    <h2 id={name} className="font-normal text-3xl text-neutral-600 my-auto">
      {data.value}
    </h2>
  );
}

export default Heading;
